<template>
   <div
      v-touch:tap="onTouchTap"
      class="product-card spacing d-flex align-items-center justify-content-center shadow"
      :class="breakpoint + (hidden ? ' collapsed' : '') + (highlight ? ' highlight' : '') + (legacy ? ' legacy' : '')">
      <!--      <div v-if="!isMoreToggle">-->
      <div
         v-if="!isMoreToggle"
         class="content d-flex align-items-center justify-content-center no-select">
         <div class="d-flex align-items-center justify-content-center gap-2">
            <findforsikring-icon
               :name="product.icon"
               :size="iconSize" />
            <div
               class="product-name"
               v-html="product.label" />
         </div>
      </div>
      <!--      </div>-->
      <div v-else>
         <div class="content more d-flex align-items-center justify-content-center no-select">
            <div class="d-flex align-items-center justify-content-center">
               <div class="icon-stack">
                  <material-icon name="brightness_1" />
                  <material-icon
                     name="more_horiz"
                     size="18"
                     style="color: #ffffff" />
               </div>
               <div class="product-name">Se {{ all ? 'færre' : 'flere' }} forsikringer</div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import FindforsikringIcon from '@components/FindforsikringIcon';
import MaterialIcon from '@components/MaterialIcon';

export default {
   name: 'ProductSelector',
   components: {
      MaterialIcon,
      FindforsikringIcon,
   },
   props: {
      product: {
         type: Object,
         default: null,
      },
      hidden: {
         type: Boolean,
         default: false,
      },
      legacy: {
         type: Boolean,
         default: false,
      },
   },
   computed: {
      ...mapGetters({
         all: 'showAllProducts',
         breakpoint: 'breakpoint',
      }),
      isMoreToggle() {
         return this.product === null;
      },
      allowIncrement() {
         return !this.isMoreToggle && this.product.count < this.product.max;
      },
      allowDecrement() {
         return !this.isMoreToggle && this.product.count > 0;
      },
      iconSize() {
         switch (this.product.icon) {
            case 'bil1':
               return 30;
            case 'indbo':
            case 'ulykke':
            case 'hus':
            case 'rejse':
            case 'livsforsikring':
            case 'dyr':
               return 27;
            case 'mc':
               return 29;
            case 'ejerskifteforsikring':
               return 24;
            case 'camping':
               return 28;
            // case 'livsforsikring': return '165%';
            // case 'dyr': return '165%';
            default:
               return 26;
         }
      },
      highlight() {
         if (this.product) {
            return this.product.count > 0;
         }
         return false;
      },
   },
   methods: {
      ...mapMutations(['addProduct', 'removeProduct', 'toggleShowAllProducts']),
      increment() {
         if (this.allowIncrement) {
            this.addProduct(this.product);
         }
      },
      decrement() {
         if (this.allowDecrement) {
            this.removeProduct(this.product);
         }
      },
      onTouchTap(e) {
         console.log('tap!', e);
         if (e.target.classList.contains('product-btn') || e.target.parentElement.classList.contains('product-btn')) {
            // Ignore - handled by increment
         }
         // Only left-click (if mouse)
         else if (e instanceof MouseEvent && e.button !== 0) {
         } else if (this.isMoreToggle) {
            this.toggleShowAllProducts();
            setTimeout(() => {
               this.$forceUpdate();
            }, 200);
            // this.$emit('toggle');
            e.preventDefault();
            e.stopImmediatePropagation();
         } else if (this.product.count === 0) {
            this.addProduct(this.product);
         } else if (this.product.count > 0) {
            this.removeProduct(this.product);
         }
      },
   },
};
</script>

<style lang="scss" scoped>
//noinspection CssUnknownTarget
@import '~/colors.scss';

.product-card {
   flex: 1 1 150px;
   max-width: 171px;
   position: relative;
   background-color: #fff;
   color: #444;
   border-radius: 4px;
   border: 2px solid #fff;
   height: 55px;
   max-height: 55px;
   min-height: 55px;
   cursor: pointer;
   font-size: 18px;

   &.sm {
      font-size: 16px;
   }

   &.xs {
      font-size: 15px;
   }

   font-weight: normal;
   line-height: 1;
   box-shadow: 0 1px 3px rgb(0 0 0 / 5%), 0 1px 2px rgb(0 0 0 / 10%);
   transition: box-shadow 0.3s, margin 0.3s, max-height 0.3s, border 0.3s, background-color 0.3s;
   will-change: box-shadow, max-width;

   &.legacy {
      box-shadow: 0 1px 3px rgb(0 0 0 / 5%), 0 1px 2px rgb(0 0 0 / 10%) !important;
   }

   //&.highlight {
   //   border: 2px solid var(--ff-blue);
   //   background-color: #e2e8fd;
   //}

   &.highlight {
      border: 2px solid var(--ff-dark-blue);
      background-color: #e9ecef;
      box-shadow: none !important;
   }

   &.collapsed {
      max-height: 0;
      /*margin: 0;*/
      max-width: 0;
      margin: 0 10px;
      overflow: hidden;
   }

   .content {
      flex-direction: column;
      margin: 5px;
      width: 100%;
      height: 100%;

      //* {
      //   transition: all 0.3s;
      //   will-change: all;
      //}

      .icon,
      .icon-stack {
         font-size: 140%;
         padding: 8px 8px 8px 0;
         max-width: 50px;
         overflow: hidden;
      }

      .product-name {
         width: min-content;
         display: -ms-grid;
         -ms-grid-columns: min-content;
      }

      .counter {
         max-height: 0;
         overflow: hidden;
         font-size: 28px;
         opacity: 0;
      }
   }

   .badge-count-center {
      position: absolute;
      text-align: center;
      line-height: 0;
      opacity: 0;
      font-size: 32px;
      //font-family: 'Amaranth', sans-serif;
      transition: opacity 0.3s;
      will-change: opacity;
   }

   .badge-count-corner {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 2px;
      position: absolute;
      top: 3px;
      right: 3px;
      background-color: var(--ff-dark-blue);
      color: #fff;
      //font-family: 'Amaranth', sans-serif;
      font-size: 16px;
      font-weight: bold;
      width: 20px;
      height: 20px;
      border-radius: 100%;
      transition: opacity 0.3s;
      will-change: opacity;

      &.zero {
         opacity: 0;
      }
   }

   .product-btn {
      position: absolute;
      width: 30px;
      height: 30px;
      background-color: var(--ff-dark-blue);
      color: #fff;
      font-size: 32px;
      border-radius: 50%;
      cursor: pointer;
      top: calc(50% - 15px);
      opacity: 0;
      transition: opacity 0.3s;
      will-change: opacity;
      display: flex;
      align-items: center;
      justify-content: center;

      &.left {
         left: -15px;
         //left: -12px;

         &:before {
            //position: absolute;
            //top: calc(50% - 1px);
            //left: calc(50% - 6px);
            //content: '-';
            //line-height: 0;
         }
      }

      &.right {
         right: -15px;
         //right: -12px;

         &:before {
            //position: absolute;
            //top: calc(50% - 1px);
            //right: calc(50% - 8px);
            //content: '+';
            //line-height: 0;
         }
      }

      &:hover {
         background-color: darken($ff-dark-blue, 10%);
      }

      &.disabled {
         cursor: not-allowed;
         background-color: lighten($ff-dark-blue, 40%);
      }
   }
}

.product-card:hover,
.product-card:active,
.product-card:focus {
   box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1), 0 2px 2px rgba(0, 0, 0, 0.2);

   .content {
      .counter {
         max-height: 50px;
         opacity: 1;
      }

      .icon {
         font-size: 100% !important;
         padding-bottom: 0;
         padding-top: 0;
         padding-right: 5px;
         /*padding: 0;*/
         /*max-width: 0;*/
         /*&::before{*/
         /*    content: '';*/
         /*}*/
      }

      //.product-name {
      //   font-size: 12px;
      //   width: auto;
      //   display: block;
      //}
   }

   .product-btn {
      opacity: 1;
   }

   .badge-count-center {
      /*opacity: 1;*/
   }

   .badge-count-corner {
      opacity: 0;
   }
}
</style>
